/**
 * @generated SignedSource<<16d723bb4bb0a285ba30ccfc370f515e>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9

import type { ConcreteRequest } from 'relay-runtime';
export type useTrackTitleRedactionRenderedRedactionsCountQuery$variables = {
  contentId: string;
};
export type useTrackTitleRedactionRenderedRedactionsCountQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly redactionMetadataCount: number | null | undefined;
  } | null | undefined;
};
export type useTrackTitleRedactionRenderedRedactionsCountQuery = {
  response: useTrackTitleRedactionRenderedRedactionsCountQuery$data;
  variables: useTrackTitleRedactionRenderedRedactionsCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "redactionMetadataCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a2231280d1a64c0467ba87a246116380",
    "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
    "metadata": {},
    "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
    "operationKind": "query",
    "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
  }
};
})();

(node as any).hash = "f9a742b4e2840cd061fc6915ae9b6b93";

export default node;
